import { render, staticRenderFns } from "./UiLoadingCircle.vue?vue&type=template&id=f1aeb85c&scoped=true"
import script from "./UiLoadingCircle.vue?vue&type=script&lang=js"
export * from "./UiLoadingCircle.vue?vue&type=script&lang=js"
import style0 from "./UiLoadingCircle.vue?vue&type=style&index=0&id=f1aeb85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aeb85c",
  null
  
)

export default component.exports